import { createContext } from 'react';
import { API } from '@shared/types/api';

export type CardChannelContextType = API.ChannelFragment | undefined;

export const CardChannelContext = createContext<CardChannelContextType>(undefined);
